import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { ApiHeaderWithToken } from '../common/apisHeaders';

export const addAdditionalService = createAsyncThunk(
  'addAdditionalService',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/additionalService/createAdditionalService`,
        data,
        ApiHeaderWithToken(),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const getAdditionalServices = createAsyncThunk(
  'getAdditionalServices',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/additionalService/getAllAdditionalServices`,
        {
          params,
          ...ApiHeaderWithToken(),
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const getAdditionalServiceById = createAsyncThunk(
  'getAdditionalServiceById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/additionalService/getAdditionalServiceById/${id}`,
        ApiHeaderWithToken(),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const updateAdditionalService = createAsyncThunk(
  'updateAdditionalService',
  async (data, { rejectWithValue }) => {
    const { id } = data;
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_API}/additionalService/updateAdditionalService/${id}`,
        data,
        ApiHeaderWithToken(),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const deleteAdditionalService = createAsyncThunk(
  'deleteAdditionalService',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_API}/additionalService/deleteAdditionalService/${id}`,
       {}, ApiHeaderWithToken(),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

const additionalServiceSlice = createSlice({
  name: 'additionalService',
  initialState: {
    services: [],
    totalCount: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addAdditionalService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAdditionalService.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addAdditionalService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAdditionalServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdditionalServices.fulfilled, (state, action) => {
        state.loading = false;
        state.services = action.payload.data || [];
        state.totalCount = action.payload.totalCount || state.services.length;
        state.error = null;
      })
      .addCase(getAdditionalServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAdditionalServiceById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdditionalServiceById.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getAdditionalServiceById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateAdditionalService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAdditionalService.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateAdditionalService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteAdditionalService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAdditionalService.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteAdditionalService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default additionalServiceSlice.reducer;
